export const reCaptchaKey = {
  data: function () {
    return {
      reCaptchaKey: typeof window.reCaptchaKey !== 'undefined' ? window.reCaptchaKey : '6Lc63aAUAAAAAG0BJzcOhUEml-ahTHwmrwZXLAmL'
    }
  },
};
